import { MediaType } from './MediaType';
import type { ResolverContext } from './resolver-context';
import { throwErrorWithResponse } from './throwErrorWithResponse';

type Network = ResolverContext['network'];

export const fetchJSON = (
	{ cfetch }: Network,
	resource: string,
	init: Parameters<Network['cfetch']>[1],
) =>
	cfetch(resource, {
		...init,
		headers: {
			Accept: MediaType.JSON,
			...init?.headers,
		},
	}).then((response) => response.json().catch((error) => throwErrorWithResponse(error, response)));
